import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.min.js';

import '@fortawesome/fontawesome-free/css/all.css';
import '@/assets/styles/site-fonts.css';
import '@/assets/styles/site-advertisers.css';

import { createApp } from 'vue'
import { createGtm } from '@gtm-support/vue-gtm';
import App from './App.vue'
import router from './router'
import store from './store'

createApp(App).use(store).use(router).use(createGtm({ id: 'GTM-TTTXN7', defer: false, compatibility: false, nonce: '2726c7f26c', enabled: true, debug: false, loadScript: true, trackOnNextTick: false })).mount('#app')
